import { SelectOption } from "@commonlibs";
import { IdentificationType } from "../IdentificationInput.types";

export default function useIdentificationInputOptions(): SelectOption<IdentificationType>[] {
    return [
        { label: "CC", value: "CC" },
        { label: "NIT", value: "NIT" },
        { label: "CE", value: "CE" },
    ];
}
